import classNames from 'classnames';

import isColumnHidden from './isColumnHidden';


/**
 * Returns a string based on column number and whether the column is hidden
 * @param {number} column
 * @param {number} scenarioCount
 */
function getCalculatorGridColumnClassNames(column, scenarioCount){
    return classNames({
        'hidden': isColumnHidden(column, scenarioCount),
        [`col-${column+1}`]: true,
    });

}

export default getCalculatorGridColumnClassNames;